import React from 'react';
import {
  Box,
  Grid,
  IconButton,
  TextField,
  FormControl,
  FormHelperText,
  Divider,
  Typography,
} from '@mui/material';
import koLocale from 'date-fns/locale/ko';
import DateAdapter from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import { useFormikContext, getIn } from 'formik';
import DeleteIcon from '@mui/icons-material/Delete';
import MultiUploadComponent from '../../common/form/MultiUploadComponent';

const SalesMultiFileForm = ({
  file,
  index,
  touched,
  errors,
  handleRemove,
  handleChange,
  handleBlur,
  project,
}) => {
  const formikProps = useFormikContext();

  // const sellPartnerUuid = `files[${index}].sellPartnerUuid`;
  // const touchedSellPartnerUuid = getIn(touched, sellPartnerUuid);
  // const errorSellPartnerUuid = getIn(errors, sellPartnerUuid);

  const fileAttrVal5 = `files[${index}].fileAttrVal5`;
  const touchedFileRegDt = getIn(touched, fileAttrVal5);
  const errorFileRegDt = getIn(errors, fileAttrVal5);

  const fileVal = `files[${index}].file`;
  const touchedFile = getIn(touched, fileVal);
  const errorFile = getIn(errors, fileVal);

  const fileDesc = `files[${index}].fileDesc`;
  const touchedFileDesc = getIn(touched, fileDesc);
  const errorFileDesc = getIn(errors, fileDesc);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          marginTop: 2,
          px: 2,
        }}
      >
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          <Grid item xs={3}>
            <Typography variant="subtitle2">매출처:</Typography>
            <Typography variant="subtitle2">{project?.vendorCmpNm}</Typography>
          </Grid>
          <Grid item xs={2}>
            <LocalizationProvider dateAdapter={DateAdapter} locale={koLocale}>
              <DatePicker
                label="받은(수신)날짜"
                inputFormat={'yyyy-MM-dd'}
                mask={'____-__-__'}
                id="fileAttrVal5"
                name="fileAttrVal5"
                value={formikProps.values.files[index].fileAttrVal5}
                onChange={(newValue) => {
                  formikProps.setFieldValue(fileAttrVal5, newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    fullWidth
                    error={Boolean(touchedFileRegDt && errorFileRegDt)}
                    helperText={
                      touchedFileRegDt && errorFileRegDt ? errorFileRegDt : ''
                    }
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={3}>
            <MultiUploadComponent index={index} formik={formikProps} />
            {touchedFile && Boolean(errorFile) && (
              <FormControl error>
                <FormHelperText>{touchedFile && errorFile}</FormHelperText>
              </FormControl>
            )}
          </Grid>
          <Grid item xs={3}>
            <TextField
              variant="standard"
              fullWidth
              name={fileDesc}
              id={fileDesc}
              value={formikProps.values.files[index].fileDesc}
              helperText={touchedFileDesc && errorFileDesc ? errorFileDesc : ''}
              error={Boolean(touchedFileDesc && errorFileDesc)}
              onChange={handleChange}
              onBlur={handleBlur}
              label="비고"
            />
          </Grid>
          <Grid item xs={1}>
            <IconButton aria-label="delete" onClick={handleRemove}>
              <DeleteIcon />
            </IconButton>
          </Grid>
        </Grid>
      </Box>
      <Divider sx={{ my: 1 }} />
    </>
  );
};

export default SalesMultiFileForm;
